import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=32043424&scoped=true&"
import script from "./update-password.vue?vue&type=script&lang=js&"
export * from "./update-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32043424",
  null
  
)

export default component.exports